import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from 'vue';

import { useCommonStore } from '@/store/common';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiCard',
  props: {
  radius: {
    type: Number as PropType<number>,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { isMobile } = storeToRefs(useCommonStore());

const style = computed(() => {
  const result: any = {};
  if (props.radius) {
    result['border-radius'] = `${props.radius}px`;
  }
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-card", { 'ai-card--mobile': _unref(isMobile) }]),
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})